// Sustainability page English translations

export default {
  pageTitle: "Sustainability",
  breadcrumbHome: "Home",
  breadcrumbSustainability: "Sustainability",
  title: "Sustainability",
  conceptsTitle: "Our Concepts of Sustainability",
  conceptsSubtitle: "Creating a sustainable future through innovation and responsibility",
  visionTitle: "Eagle Industry's Sustainability Vision",
  visionDesc1: "At Eagle Industry Indonesia, we believe that companies belong to not only their shareholders but also their employees and society. This philosophy has long permeated every aspect of the EKK Group's management since our establishment in 1990.",
  visionDesc2: "As part of Eagle Industry Co., Ltd., a global leader in sealing solutions, we contribute to environmental protection through our core business. Our mechanical seals prevent gases, oil, and other fluids from leaking machinery, directly helping to preserve the environment and prevent pollution.",
  corePrinciples: "Our Core Principles:",
  principle1: "Environmental protection through leak prevention technology",
  principle2: "Building trust through dialogue with all stakeholders",
  principle3: "Creating fair profits that support perpetual growth",
  principle4: "Developing products that resolve environmental regulatory issues",
  learnMoreConcept: "Learn More About Our Sustainability Concept",
  
  esgTitle: "ESG Initiatives",
  esgSubtitle: "Strengthening our Environmental, Social, and Governance framework",
  environmentalTitle: "Environmental Initiatives",
  environmentalDesc: "Comprehensive environmental preservation activities in accordance with our environmental policy and ISO 14001 certification.",
  environmentalFeature1: "Water resource management",
  environmentalFeature2: "Global warming mitigation",
  environmentalFeature3: "Industrial waste reduction",
  
  
  healthTitle: "Occupational Health & Safety",
  healthDesc: "Comprehensive OHS management system ensuring workplace safety and employee well-being.",
  healthFeature1: "Safety management systems",
  healthFeature2: "Health promotion programs",
  healthFeature3: "Safety training and education",
  
  socialTitle: "Social Contribution Initiatives",
  socialDesc: "Implementing comprehensive social programs that support community development, education, and environmental stewardship.",
  socialFeature1: "Sustainability awareness campaigns",
  socialFeature2: "ESG performance transparency",
  socialFeature3: "Community engagement",
  
  learnMore: "Learn More",
  
  ctaTitle: "Join Our Sustainability Journey",
  ctaDesc: "We are committed to creating sustainable value for all our stakeholders. Together, we can build a more sustainable future through innovation, responsibility, and collaboration.",
  contactUs: "Contact Us"
};